<template>
  <div class="home">
    <Registration/>
  </div>
</template>

<script>
// @ is an alias to /src
import Registration from '@/components/Registration.vue'

export default {
  name: 'home',
  components: {
    Registration
  }
}
</script>
